/** Client-side helpers for turning a local .md file into a knowledge article. */

export function isMarkdownFilename(name: string): boolean {
  return name.toLowerCase().endsWith(".md");
}

/** Title from basename without the .md suffix. */
export function titleFromMarkdownFilename(name: string): string {
  const base = name.replace(/^.*[/\\]/, "");
  const withoutExt = base.replace(/\.md$/i, "").trim();
  return withoutExt || "Untitled";
}

export function rejectNonMarkdownMessage(): string {
  return "Only Markdown (.md) files can be uploaded.";
}
